import { ApolloProvider } from '@apollo/client';
import * as React from 'react';
import { diContainer } from 'src/dependencyInjection/diContainer';
import { DI_TYPES } from 'src/dependencyInjection/diTypes';
import { IApolloService } from 'src/services/ApolloService/IApolloService';
import { Toaster } from 'react-hot-toast';
import { InvalidSubscriptionModal } from './InvalidSubscriptionModal';
import { TooltipProvider } from 'src/shadcn/components/ui/tooltip';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './ThemeProvider';
import { NextUIProvider } from '@nextui-org/react';

const queryClient = new QueryClient();

export const ClientPage: React.FunctionComponent<
  React.PropsWithChildren
> = props => {
  const [hasMounted, setHasMounted] = React.useState(false);
  const apolloService = diContainer.get<IApolloService>(DI_TYPES.ApolloService);
  const [hasError, setHasError] = React.useState(false);
  React.useEffect(() => {
    setHasMounted(true);
    apolloService.setOnError(() => {
      setHasError(true);
    });
  }, []);

  if (!hasMounted) {
    return null;
  }
  return (
    <NextUIProvider>
      {/* <ThemeProvider attribute='class' defaultTheme='light' enableSystem> */}
      <InvalidSubscriptionModal isOpen={hasError} setIsOpen={setHasError} />
      <QueryClientProvider client={queryClient}>
        <ApolloProvider client={apolloService.getClient()}>
          <TooltipProvider>
            {props.children}
            <Toaster toastOptions={{ position: 'bottom-center' }} />
          </TooltipProvider>
        </ApolloProvider>
      </QueryClientProvider>
      {/* </ThemeProvider> */}
    </NextUIProvider>
  );
};
